import React from 'react'
import Panel from '../ds/Panel'

/**
 * Kepala halaman (page head) — pola T7 Design System KLH/BPLH v2.1: judul + aksi
 * di dalam panel. Subtitle tampil sebagai eyebrow, judul memakai skala .t-h2.
 * Pada layar sempit judul dan aksi menumpuk agar tidak memicu overflow horizontal.
 */
export default function HeaderPage({ title, subtitle, action }) {
    return (
        <Panel className='p-[18px]'>
            <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
                <div className='flex flex-col gap-1'>
                    {
                        subtitle && (
                            <span className='text-xs font-semibold uppercase tracking-[0.08em] text-ink-400'>
                                { subtitle }
                            </span>
                        )
                    }
                    <h1 className='t-h2 text-g-700'>{ title }</h1>
                </div>
                { action }
            </div>
        </Panel>
    )
}
